import { render } from "./tw-menu-topbar.vue?vue&type=template&id=05244844"
import script from "./tw-menu-topbar.vue?vue&type=script&lang=js"
export * from "./tw-menu-topbar.vue?vue&type=script&lang=js"
script.render = render

export default script